// extracted by mini-css-extract-plugin
module.exports = {"container":"DealModal_container__3_iVL"};